module.exports = __webpack_public_path__ + "static/media/fruit.7434c2a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/fruit.png
// module id = 11
// module chunks = 0